<template>
  <div class="details">
    <div class="box">
      <DetailsItem v-bind="getProps"/>
      <div class="option-box">
        <h4>大家的态度：</h4>
        <div class="option-box-item" v-for="item of options" :key="item.id">
          <span :class="{ percentage: true, active: item.choose }">{{showAct ? item.actPercent : item.prePercent}}%</span>
          <div class="desc">{{item.content}}</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div @click="goDynamic" :style="{ width: (platform !== 'notInDingTalk') ? '43.2vw' : '100%' }">探索更多</div>
      <div v-if="platform !== 'notInDingTalk'" @click="getShareContent" class="share">邀请同事</div>
    </div>
  </div>
</template>
<script>
import DetailsItem from './topicDetailItem'
import dd from 'DD'
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
import { createNamespacedHelpers } from 'vuex'
import Mixins from '../../../minixs/ddMixis'
const { mapActions } = createNamespacedHelpers('tabbar')
export default {
  mixins: [Mixins],
  components: {
    DetailsItem
  },
  data () {
    return {
      platform: dd.env.platform,
      showError: false,
      id: '',
      imageURL: '',
      subTitle: '',
      title: '',
      options: [],
      preCount: 0,
      showAct: false
    }
  },
  mounted () {
    this.getTopicDetails()
  },
  methods: {
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    goDynamic () {
      this.updateTabIndex('find')
      this.$router.push({
        path: '/exerland/bbs/find'
      })
    },
    getTopicDetails () {
      const user = getUser('user')
      const { id } = this.$route.params
      const promise = get({
        url: `/topic/h5TopicDetailPrecent/${id}/${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          const { imageURL, options, preCount, subTitle, title, showAct } = detail
          this.imageURL = imageURL
          this.options = options
          this.preCount = preCount
          this.subTitle = subTitle
          this.title = title
          this.showAct = showAct
        }
      })
    }
  },
  computed: {
    getProps () {
      return {
        imageURL: this.imageURL,
        preCount: this.preCount,
        subTitle: this.subTitle,
        title: this.title
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.details {
  height: 100vh;
  .box {
    height: calc(100% - 50px);
    overflow-y: scroll;
    .option-box {
      padding: 9px 16px 19px;
      h4 {
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 25px;
        margin-bottom: 24px;
      }
      .option-box-item {
        margin-bottom: 16px;
        height: 52px;
        width: 100%;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .percentage {
          width: 52px;
          height: 52px;
          background: rgba(245, 245, 245, 1);
          text-align: center;
          line-height: 52px;
          display: inline-block;
        }
        .desc {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          width: calc(100% - 69px);
        }
      }
      .active {
        background: rgba(24, 204, 159, 0.1);
        color: rgba(0, 150, 136, 1);
      }
    }
  }
  .footer {
    width: 100%;
    height:50px;
    padding: 0 16px;
    box-sizing: border-box;
    display: flex;
    justify-content:space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    div {
      width: 43.2vw;
      font-size:17px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      line-height:24px;
      height:44px;
      background:rgba(245,245,245,1);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .share {
      background:rgba(24,204,159,1);
      font-weight:600;
      color:rgba(255,255,255,1);
    }
  }
}
</style>
